import { render, staticRenderFns } from "./PasswordExpired.component.vue?vue&type=template&id=6c3f7b3a&"
import script from "./PasswordExpired.component.vue?vue&type=script&lang=ts&"
export * from "./PasswordExpired.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports